<template>
  <svg :class="className" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-test-id="icon">
    <use :xlink:href="symbolId" />
  </svg>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  const props = withDefaults(defineProps<{
    name: string;
    prefix?: string;
  }>(), { prefix: 'icon' });

  const symbolId = computed(() => `#${props.prefix}-${props.name}`);
  const className = computed(() => ['svg-icon', `svg-icon--${props.name}`]);
</script>

<style lang="scss" scoped>
  .svg-icon {
    fill: currentColor;
    width: 100%;
    height: 100%;
  }
</style>
